import script from "./MyDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./MyDetail.vue?vue&type=script&setup=true&lang=js"

import "./MyDetail.vue?vue&type=style&index=0&id=876ccda8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-876ccda8"]])

export default __exports__